import React from "react";
import { render } from 'react-dom';
import { CartGrid } from './cartGrid';

(function init() {
  const selectors = {
    root: '[data-cart-product-grid]',
  }

  const rootElement = document.querySelector(selectors.root);

  if (!rootElement) return;

  render(<HandleProductGrid />, rootElement)
})();

function HandleProductGrid() {
  return (
    <CartGrid />
  );
}
